import axios from "axios";

const api = axios.create({
	baseURL: process.env.REACT_APP_API_BASE_URL,
	headers: { "Content-Type": "application/json" },
});

export const getBooths = async () => {
	try {
		console.log("api call was sent...");
		const response = await api.get("/api/booths/getAll");
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		console.log(errorMessage);
		throw new Error(errorMessage);
	}
};

export const addTimeSlots = async () => {
	try {
		console.log("api call was sent...");
		const response = await api.post("/api/booths/addTimeSlots");
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const registerUser = async (userData) => {
	try {
		const response = await api.post("/api/user/register", userData);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const updateUserInfo = async (userData) => {
	try {
		const response = await api.post("/api/user/updateInfo", userData);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const startSession = async (sessionData) => {
	try {
		const response = await api.post("/api/sessions/start", sessionData);
		return {
			...response.data,
			sessionId: response.data.session._id,
		};
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const getActiveSession = async (userId) => {
	try {
		const response = await api.get(`/api/sessions/active/${userId}`);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const getAvailableBooths = async (params) => {
	try {
		const response = await api.post("/api/sessions/getAvailableBooths", {
			startTime: params.startTime,
			duration: params.duration,
			boothType: params.boothType,
			locationId: params.locationId,
			date: params.date,
			boothId: params.boothId,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const getBoothAvailability = async (params) => {
	try {
		const response = await api.post("/api/sessions/getBoothAvailability", {
			boothId: params.boothId,
			locationId: params.locationId,
			date: params.date,
			duration: params.duration,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const getCheckoutInfo = async (token) => {
	try {
		const response = await api.get(`/api/sessions/checkout/${token}`);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const reserveBooth = async (sessionData) => {
	try {
		const response = await api.post("/api/sessions/reserve", sessionData);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const cancelLockedSession = async (sessionId) => {
	try {
		const response = await api.post("/api/sessions/cancelLocked", {
			sessionId,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const checkTermsAndEmail = async (phone, email) => {
	try {
		const response = await api.post("/api/user/checkTermsAndEmail", {
			phone,
			email,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const temproraryReservation = async (
	boothId,
	building,
	startTime,
	endTime,
	locationId,
	date
) => {
	try {
		const response = await api.post("/api/sessions/temporaryReservation", {
			boothId,
			building,
			startTime,
			endTime,
			locationId,
			date,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const getSessionStatus = async (sessionId) => {
	try {
		const response = await api.post(`/api/sessions/getSessionStatus`, {
			sessionId,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const sendCode = async (phone) => {
	try {
		const response = await api.post("/api/user/sendCode", { phone });
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const approveCode = async (phone, code) => {
	try {
		const response = await api.post("/api/user/approveCode", { phone, code });
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const cancelSession = async (sessionId, phoneNumber) => {
	try {
		const response = await api.post(`/api/sessions/cancel`, {
			sessionId,
			phoneNumber,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const verifyBoothAvailability = async (
	boothId,
	time,
	endTime,
	locationId,
	sessionId
) => {
	try {
		const response = await api.post("/api/sessions/verifyBoothAvailability", {
			boothId,
			time,
			endTime,
			locationId,
			sessionId,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const markSessionAsAbandoned = async (sessionId) => {
	try {
		const response = await api.post(`/api/sessions/abandon`, { sessionId });
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

// Dev

export const resetTimeSlots = async () => {
	try {
		const response = await api.post("/api/dev/resetTimeSlots");
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const updateTimeSlot = async () => {
	try {
		const response = await api.post("/api/dev/updateTimeSlot");
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const getLocation = async (locationId) => {
	try {
		const response = await api.get(`/api/sessions/getLocation/${locationId}`);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const getBoothData = async (boothId) => {
	try {
		const response = await api.get(`/api/booths/${boothId}`);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

// Get booth data with SALTO integration info (lockId, saltoLocationId)
export const getBoothWithSaltoData = async (boothId) => {
	try {
		const response = await api.get(`/api/booths/${boothId}`);
		const booth = response.data.booth;
		console.log({ booth });

		// Return booth data with easy access to SALTO information
		return {
			...response.data,
			saltoInfo: {
				lockId: booth.lockId,
				saltoLocationId: booth.location?.saltoLocationId,
				locationName: booth.location?.name,
			},
		};
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

// Get booth occupancy status
export const getBoothStatus = async (boothId) => {
	try {
		console.log("🔍 [API] Checking booth status for:", boothId);
		const response = await api.get(`/api/booths/${boothId}/status`);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		console.error("❌ [API] Error checking booth status:", errorMessage);
		throw new Error(errorMessage);
	}
};

// Unlock session using Salto API
export const unlockSession = async (sessionId) => {
	try {
		console.log("🔓 [API] Attempting to unlock session:", sessionId);
		const response = await api.post("/api/sessions/unlock", { sessionId });
		console.log("🔓 [API] Unlock response:", response.data);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		console.error("🔓 [API] Unlock failed:", errorMessage);
		throw new Error(errorMessage);
	}
};

// Walkup flow API endpoints
export const resolveUser = async (phone, boothId) => {
	try {
		const response = await api.post("/api/walkup/auth/resolve-user", {
			phone,
			boothId,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const updateProfile = async (userId, firstName, lastName, email) => {
	try {
		const response = await api.post("/api/walkup/auth/update-profile", {
			userId,
			firstName,
			lastName,
			email,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const completeSetup = async (userId, setupIntentId, paymentMethodId) => {
	try {
		const response = await api.post("/api/walkup/payments/setup-complete", {
			userId,
			setupIntentId,
			paymentMethodId,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const unlockBooth = async (userId, boothId) => {
	try {
		const response = await api.post("/api/walkup/payments/unlock", {
			userId,
			boothId,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const getWalkupSessionStatus = async (sessionId) => {
	try {
		const response = await api.get(`/api/walkup/sessions/${sessionId}/status`);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export const endSessionManual = async (sessionId) => {
	try {
		const response = await api.post("/api/walkup/sessions/end-manual", {
			sessionId,
		});
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

// Occupancy monitoring API calls
export const checkBoothOccupancy = async (sessionId) => {
	try {
		const response = await api.get(`/api/sessions/${sessionId}/check-occupancy`);
		return response.data;
	} catch (error) {
		const errorMessage = error.response?.data?.message || error.message;
		throw new Error(errorMessage);
	}
};

export default api;
